const active = "Active";
const closing = "Closing";
const frozen = "Frozen";
const closed = "Closed";
const suspended = "Suspended";

const transitionRules = {
  [active]: {
    [active]: false,
    [suspended]: false,
    [frozen]: true,
    [closing]: true,
    [closed]: true,
  },
  [suspended]: {
    [active]: false,
    [suspended]: false,
    [frozen]: true,
    [closing]: true,
    [closed]: true,
  },
  [frozen]: {
    [active]: true,
    [suspended]: true,
    [frozen]: true,
    [closing]: true,
    [closed]: true,
  },
  [closing]: {
    [active]: false,
    [suspended]: false,
    [frozen]: true,
    [closing]: true,
    [closed]: true,
  },
  [closed]: {
    [active]: true,
    [suspended]: true,
    [frozen]: true,
    [closing]: true,
    [closed]: true,
  },
};

export const isNotAllowSwitching = (from, to) => {
  if (
    !transitionRules[from] ||
    typeof transitionRules[from][to] === "undefined"
  ) {
    return false;
  }

  return transitionRules[from][to];
};
